export const dialCodes = [
    {
      name: "Afghanistan",
      dialCode: "+93",
      countryCode: "AF",
      maxLength:10
    },
    {
      name: "Aland Islands",
      dialCode: "+358",
      countryCode: "AX",
      maxLength:10
    },
    {
      name: "Albania",
      dialCode: "+355",
      countryCode: "AL",
      maxLength:10
    },
    {
      name: "Algeria",
      dialCode: "+213",
      countryCode: "DZ",
      maxLength:10
    },
    {
      name: "AmericanSamoa",
      dialCode: "+1684",
      countryCode: "AS",
      maxLength:10
    },
    {
      name: "Andorra",
      dialCode: "+376",
      countryCode: "AD",
      maxLength:10
    },
    {
      name: "Angola",
      dialCode: "+244",
      countryCode: "AO",
      maxLength:10
    },
    {
      name: "Anguilla",
      dialCode: "+1264",
      countryCode: "AI",
      maxLength:10
    },
    {
      name: "Antarctica",
      dialCode: "+672",
      countryCode: "AQ",
      maxLength:10
    },
    {
      name: "Antigua and Barbuda",
      dialCode: "+1268",
      countryCode: "AG",
      maxLength:10
    },
    {
      name: "Argentina",
      dialCode: "+54",
      countryCode: "AR",
      maxLength:10
    },
    {
      name: "Armenia",
      dialCode: "+374",
      countryCode: "AM",
      maxLength:10
    },
    {
      name: "Aruba",
      dialCode: "+297",
      countryCode: "AW",
      maxLength:10
    },
    {
      name: "Australia",
      dialCode: "+61",
      countryCode: "AU",
      maxLength:10
    },
    {
      name: "Austria",
      dialCode: "+43",
      countryCode: "AT",
      maxLength:10
    },
    {
      name: "Azerbaijan",
      dialCode: "+994",
      countryCode: "AZ",
      maxLength:10
    },
    {
      name: "Bahamas",
      dialCode: "+1242",
      countryCode: "BS",
      maxLength:10
    },
    {
      name: "Bahrain",
      dialCode: "+973",
      countryCode: "BH",
      maxLength:10
    },
    {
      name: "Bangladesh",
      dialCode: "+880",
      countryCode: "BD",
      maxLength:10
    },
    {
      name: "Barbados",
      dialCode: "+1246",
      countryCode: "BB",
      maxLength:10
    },
    {
      name: "Belarus",
      dialCode: "+375",
      countryCode: "BY",
      maxLength:10
    },
    {
      name: "Belgium",
      dialCode: "+32",
      countryCode: "BE",
      maxLength:10
    },
    {
      name: "Belize",
      dialCode: "+501",
      countryCode: "BZ",
      maxLength:10
    },
    {
      name: "Benin",
      dialCode: "+229",
      countryCode: "BJ",
      maxLength:10
    },
    {
      name: "Bermuda",
      dialCode: "+1441",
      countryCode: "BM",
      maxLength:10
    },
    {
      name: "Bhutan",
      dialCode: "+975",
      countryCode: "BT",
      maxLength:10
    },
    {
      name: "Bolivia, Plurinational State of",
      dialCode: "+591",
      countryCode: "BO",
      maxLength:10
    },
    {
      name: "Bosnia and Herzegovina",
      dialCode: "+387",
      countryCode: "BA",
      maxLength:10
    },
    {
      name: "Botswana",
      dialCode: "+267",
      countryCode: "BW",
      maxLength:10
    },
    {
      name: "Brazil",
      dialCode: "+55",
      countryCode: "BR",
      maxLength:10
    },
    {
      name: "British Indian Ocean Territory",
      dialCode: "+246",
      countryCode: "IO",
      maxLength:10
    },
    {
      name: "Brunei Darussalam",
      dialCode: "+673",
      countryCode: "BN",
      maxLength:10
    },
    {
      name: "Bulgaria",
      dialCode: "+359",
      countryCode: "BG",
      maxLength:10
    },
    {
      name: "Burkina Faso",
      dialCode: "+226",
      countryCode: "BF",
      maxLength:10
    },
    {
      name: "Burundi",
      dialCode: "+257",
      countryCode: "BI",
      maxLength:10
    },
    {
      name: "Cambodia",
      dialCode: "+855",
      countryCode: "KH",
      maxLength:10
    },
    {
      name: "Cameroon",
      dialCode: "+237",
      countryCode: "CM",
      maxLength:10
    },
    {
      name: "Canada",
      dialCode: "+1",
      countryCode: "CA",
      maxLength:10
    },
    {
      name: "Cape Verde",
      dialCode: "+238",
      countryCode: "CV",
      maxLength:10
    },
    {
      name: "Cayman Islands",
      dialCode: "+ 345",
      countryCode: "KY",
      maxLength:10
    },
    {
      name: "Central African Republic",
      dialCode: "+236",
      countryCode: "CF",
      maxLength:10
    },
    {
      name: "Chad",
      dialCode: "+235",
      countryCode: "TD",
      maxLength:10
    },
    {
      name: "Chile",
      dialCode: "+56",
      countryCode: "CL",
      maxLength:10
    },
    {
      name: "China",
      dialCode: "+86",
      countryCode: "CN",
      maxLength:10
    },
    {
      name: "Christmas Island",
      dialCode: "+61",
      countryCode: "CX",
      maxLength:10
    },
    {
      name: "Cocos (Keeling) Islands",
      dialCode: "+61",
      countryCode: "CC",
      maxLength:10
    },
    {
      name: "Colombia",
      dialCode: "+57",
      countryCode: "CO",
      maxLength:10
    },
    {
      name: "Comoros",
      dialCode: "+269",
      countryCode: "KM",
      maxLength:10
    },
    {
      name: "Congo",
      dialCode: "+242",
      countryCode: "CG",
      maxLength:10
    },
    {
      name: "Congo, The Democratic Republic of the Congo",
      dialCode: "+243",
      countryCode: "CD",
      maxLength:10
    },
    {
      name: "Cook Islands",
      dialCode: "+682",
      countryCode: "CK",
      maxLength:10
    },
    {
      name: "Costa Rica",
      dialCode: "+506",
      countryCode: "CR",
      maxLength:10
    },
    {
      name: "Cote d'Ivoire",
      dialCode: "+225",
      countryCode: "CI",
      maxLength:10
    },
    {
      name: "Croatia",
      dialCode: "+385",
      countryCode: "HR",
      maxLength:10
    },
    {
      name: "Cuba",
      dialCode: "+53",
      countryCode: "CU",
      maxLength:10
    },
    {
      name: "Cyprus",
      dialCode: "+357",
      countryCode: "CY",
      maxLength:10
    },
    {
      name: "Czech Republic",
      dialCode: "+420",
      countryCode: "CZ",
      maxLength:10
    },
    {
      name: "Denmark",
      dialCode: "+45",
      countryCode: "DK",
      maxLength:10
    },
    {
      name: "Djibouti",
      dialCode: "+253",
      countryCode: "DJ",
      maxLength:10
    },
    {
      name: "Dominica",
      dialCode: "+1767",
      countryCode: "DM",
      maxLength:10
    },
    {
      name: "Dominican Republic",
      dialCode: "+1849",
      countryCode: "DO",
      maxLength:10
    },
    {
      name: "Ecuador",
      dialCode: "+593",
      countryCode: "EC",
      maxLength:10
    },
    {
      name: "Egypt",
      dialCode: "+20",
      countryCode: "EG",
      maxLength:10
    },
    {
      name: "El Salvador",
      dialCode: "+503",
      countryCode: "SV",
      maxLength:10
    },
    {
      name: "Equatorial Guinea",
      dialCode: "+240",
      countryCode: "GQ",
      maxLength:10
    },
    {
      name: "Eritrea",
      dialCode: "+291",
      countryCode: "ER",
      maxLength:10
    },
    {
      name: "Estonia",
      dialCode: "+372",
      countryCode: "EE",
      maxLength:10
    },
    {
      name: "Ethiopia",
      dialCode: "+251",
      countryCode: "ET",
      maxLength:10
    },
    {
      name: "Falkland Islands (Malvinas)",
      dialCode: "+500",
      countryCode: "FK",
      maxLength:10
    },
    {
      name: "Faroe Islands",
      dialCode: "+298",
      countryCode: "FO",
      maxLength:10
    },
    {
      name: "Fiji",
      dialCode: "+679",
      countryCode: "FJ",
      maxLength:10
    },
    {
      name: "Finland",
      dialCode: "+358",
      countryCode: "FI",
      maxLength:10
    },
    {
      name: "France",
      dialCode: "+33",
      countryCode: "FR",
      maxLength:10
    },
    {
      name: "French Guiana",
      dialCode: "+594",
      countryCode: "GF",
      maxLength:10
    },
    {
      name: "French Polynesia",
      dialCode: "+689",
      countryCode: "PF",
      maxLength:10
    },
    {
      name: "Gabon",
      dialCode: "+241",
      countryCode: "GA",
      maxLength:10
    },
    {
      name: "Gambia",
      dialCode: "+220",
      countryCode: "GM",
      maxLength:10
    },
    {
      name: "Georgia",
      dialCode: "+995",
      countryCode: "GE",
      maxLength:10
    },
    {
      name: "Germany",
      dialCode: "+49",
      countryCode: "DE",
      maxLength:10
    },
    {
      name: "Ghana",
      dialCode: "+233",
      countryCode: "GH",
      maxLength:10
    },
    {
      name: "Gibraltar",
      dialCode: "+350",
      countryCode: "GI",
      maxLength:10
    },
    {
      name: "Greece",
      dialCode: "+30",
      countryCode: "GR",
      maxLength:10
    },
    {
      name: "Greenland",
      dialCode: "+299",
      countryCode: "GL",
      maxLength:10
    },
    {
      name: "Grenada",
      dialCode: "+1473",
      countryCode: "GD",
      maxLength:10
    },
    {
      name: "Guadeloupe",
      dialCode: "+590",
      countryCode: "GP",
      maxLength:10
    },
    {
      name: "Guam",
      dialCode: "+1671",
      countryCode: "GU",
      maxLength:10
    },
    {
      name: "Guatemala",
      dialCode: "+502",
      countryCode: "GT",
      maxLength:10
    },
    {
      name: "Guernsey",
      dialCode: "+44",
      countryCode: "GG",
      maxLength:10
    },
    {
      name: "Guinea",
      dialCode: "+224",
      countryCode: "GN",
      maxLength:10
    },
    {
      name: "Guinea-Bissau",
      dialCode: "+245",
      countryCode: "GW",
      maxLength:10
    },
    {
      name: "Guyana",
      dialCode: "+595",
      countryCode: "GY",
      maxLength:10
    },
    {
      name: "Haiti",
      dialCode: "+509",
      countryCode: "HT",
      maxLength:10
    },
    {
      name: "Holy See (Vatican City State)",
      dialCode: "+379",
      countryCode: "VA",
      maxLength:10
    },
    {
      name: "Honduras",
      dialCode: "+504",
      countryCode: "HN",
      maxLength:10
    },
    {
      name: "Hong Kong",
      dialCode: "+852",
      countryCode: "HK",
      maxLength:10
    },
    {
      name: "Hungary",
      dialCode: "+36",
      countryCode: "HU",
      maxLength:10
    },
    {
      name: "Iceland",
      dialCode: "+354",
      countryCode: "IS",
      maxLength:10
    },
    {
      name: "India",
      dialCode: "+91",
      countryCode: "IN",
      maxLength:10
    },
    {
      name: "Indonesia",
      dialCode: "+62",
      countryCode: "ID",
      maxLength:10
    },
    {
      name: "Iran, Islamic Republic of Persian Gulf",
      dialCode: "+98",
      countryCode: "IR",
      maxLength:10
    },
    {
      name: "Iraq",
      dialCode: "+964",
      countryCode: "IQ",
      maxLength:10
    },
    {
      name: "Ireland",
      dialCode: "+353",
      countryCode: "IE",
      maxLength:10
    },
    {
      name: "Isle of Man",
      dialCode: "+44",
      countryCode: "IM",
      maxLength:10
    },
    {
      name: "Israel",
      dialCode: "+972",
      countryCode: "IL",
      maxLength:10
    },
    {
      name: "Italy",
      dialCode: "+39",
      countryCode: "IT",
      maxLength:10
    },
    {
      name: "Jamaica",
      dialCode: "+1876",
      countryCode: "JM",
      maxLength:10
    },
    {
      name: "Japan",
      dialCode: "+81",
      countryCode: "JP",
      maxLength:10
    },
    {
      name: "Jersey",
      dialCode: "+44",
      countryCode: "JE",
      maxLength:10
    },
    {
      name: "Jordan",
      dialCode: "+962",
      countryCode: "JO",
      maxLength:10
    },
    {
      name: "Kazakhstan",
      dialCode: "+77",
      countryCode: "KZ",
      maxLength:10
    },
    {
      name: "Kenya",
      dialCode: "+254",
      countryCode: "KE",
      maxLength:10
    },
    {
      name: "Kiribati",
      dialCode: "+686",
      countryCode: "KI",
      maxLength:10
    },
    {
      name: "Korea, Democratic People's Republic of Korea",
      dialCode: "+850",
      countryCode: "KP",
      maxLength:10
    },
    {
      name: "Korea, Republic of South Korea",
      dialCode: "+82",
      countryCode: "KR",
      maxLength:10
    },
    {
      name: "Kuwait",
      dialCode: "+965",
      countryCode: "KW",
      maxLength:10
    },
    {
      name: "Kyrgyzstan",
      dialCode: "+996",
      countryCode: "KG",
      maxLength:10
    },
    {
      name: "Laos",
      dialCode: "+856",
      countryCode: "LA",
      maxLength:10
    },
    {
      name: "Latvia",
      dialCode: "+371",
      countryCode: "LV",
      maxLength:10
    },
    {
      name: "Lebanon",
      dialCode: "+961",
      countryCode: "LB",
      maxLength:10
    },
    {
      name: "Lesotho",
      dialCode: "+266",
      countryCode: "LS",
      maxLength:10
    },
    {
      name: "Liberia",
      dialCode: "+231",
      countryCode: "LR",
      maxLength:10
    },
    {
      name: "Libyan Arab Jamahiriya",
      dialCode: "+218",
      countryCode: "LY",
      maxLength:10
    },
    {
      name: "Liechtenstein",
      dialCode: "+423",
      countryCode: "LI",
      maxLength:10
    },
    {
      name: "Lithuania",
      dialCode: "+370",
      countryCode: "LT",
      maxLength:10
    },
    {
      name: "Luxembourg",
      dialCode: "+352",
      countryCode: "LU",
      maxLength:10
    },
    {
      name: "Macao",
      dialCode: "+853",
      countryCode: "MO",
      maxLength:10
    },
    {
      name: "Macedonia",
      dialCode: "+389",
      countryCode: "MK",
      maxLength:10
    },
    {
      name: "Madagascar",
      dialCode: "+261",
      countryCode: "MG",
      maxLength:10
    },
    {
      name: "Malawi",
      dialCode: "+265",
      countryCode: "MW",
      maxLength:10
    },
    {
      name: "Malaysia",
      dialCode: "+60",
      countryCode: "MY",
      maxLength:10
    },
    {
      name: "Maldives",
      dialCode: "+960",
      countryCode: "MV",
      maxLength:10
    },
    {
      name: "Mali",
      dialCode: "+223",
      countryCode: "ML",
      maxLength:10
    },
    {
      name: "Malta",
      dialCode: "+356",
      countryCode: "MT",
      maxLength:10
    },
    {
      name: "Marshall Islands",
      dialCode: "+692",
      countryCode: "MH",
      maxLength:10
    },
    {
      name: "Martinique",
      dialCode: "+596",
      countryCode: "MQ",
      maxLength:10
    },
    {
      name: "Mauritania",
      dialCode: "+222",
      countryCode: "MR",
      maxLength:10
    },
    {
      name: "Mauritius",
      dialCode: "+230",
      countryCode: "MU",
      maxLength:10
    },
    {
      name: "Mayotte",
      dialCode: "+262",
      countryCode: "YT",
      maxLength:10
    },
    {
      name: "Mexico",
      dialCode: "+52",
      countryCode: "MX",
      maxLength:10
    },
    {
      name: "Micronesia, Federated States of Micronesia",
      dialCode: "+691",
      countryCode: "FM",
      maxLength:10
    },
    {
      name: "Moldova",
      dialCode: "+373",
      countryCode: "MD",
      maxLength:10
    },
    {
      name: "Monaco",
      dialCode: "+377",
      countryCode: "MC",
      maxLength:10
    },
    {
      name: "Mongolia",
      dialCode: "+976",
      countryCode: "MN",
      maxLength:10
    },
    {
      name: "Montenegro",
      dialCode: "+382",
      countryCode: "ME",
      maxLength:10
    },
    {
      name: "Montserrat",
      dialCode: "+1664",
      countryCode: "MS",
      maxLength:10
    },
    {
      name: "Morocco",
      dialCode: "+212",
      countryCode: "MA",
      maxLength:10
    },
    {
      name: "Mozambique",
      dialCode: "+258",
      countryCode: "MZ",
      maxLength:10
    },
    {
      name: "Myanmar",
      dialCode: "+95",
      countryCode: "MM",
      maxLength:10
    },
    {
      name: "Namibia",
      dialCode: "+264",
      countryCode: "NA",
      maxLength:10
    },
    {
      name: "Nauru",
      dialCode: "+674",
      countryCode: "NR",
      maxLength:10
    },
    {
      name: "Nepal",
      dialCode: "+977",
      countryCode: "NP",
      maxLength:10
    },
    {
      name: "Netherlands",
      dialCode: "+31",
      countryCode: "NL",
      maxLength:10
    },
    {
      name: "Netherlands Antilles",
      dialCode: "+599",
      countryCode: "AN",
      maxLength:10
    },
    {
      name: "New Caledonia",
      dialCode: "+687",
      countryCode: "NC",
      maxLength:10
    },
    {
      name: "New Zealand",
      dialCode: "+64",
      countryCode: "NZ",
      maxLength:10
    },
    {
      name: "Nicaragua",
      dialCode: "+505",
      countryCode: "NI",
      maxLength:10
    },
    {
      name: "Niger",
      dialCode: "+227",
      countryCode: "NE",
      maxLength:10
    },
    {
      name: "Nigeria",
      dialCode: "+234",
      countryCode: "NG",
      maxLength:10
    },
    {
      name: "Niue",
      dialCode: "+683",
      countryCode: "NU",
      maxLength:10
    },
    {
      name: "Norfolk Island",
      dialCode: "+672",
      countryCode: "NF",
      maxLength:10
    },
    {
      name: "Northern Mariana Islands",
      dialCode: "+1670",
      countryCode: "MP",
      maxLength:10
    },
    {
      name: "Norway",
      dialCode: "+47",
      countryCode: "NO",
      maxLength:10
    },
    {
      name: "Oman",
      dialCode: "+968",
      countryCode: "OM",
      maxLength:10
    },
    {
      name: "Pakistan",
      dialCode: "+92",
      countryCode: "PK",
      maxLength:10
    },
    {
      name: "Palau",
      dialCode: "+680",
      countryCode: "PW",
      maxLength:10
    },
    {
      name: "Palestinian Territory, Occupied",
      dialCode: "+970",
      countryCode: "PS",
      maxLength:10
    },
    {
      name: "Panama",
      dialCode: "+507",
      countryCode: "PA",
      maxLength:10
    },
    {
      name: "Papua New Guinea",
      dialCode: "+675",
      countryCode: "PG",
      maxLength:10
    },
    {
      name: "Paraguay",
      dialCode: "+595",
      countryCode: "PY",
      maxLength:10
    },
    {
      name: "Peru",
      dialCode: "+51",
      countryCode: "PE",
      maxLength:10
    },
    {
      name: "Philippines",
      dialCode: "+63",
      countryCode: "PH",
      maxLength:10
    },
    {
      name: "Pitcairn",
      dialCode: "+872",
      countryCode: "PN",
      maxLength:10
    },
    {
      name: "Poland",
      dialCode: "+48",
      countryCode: "PL",
      maxLength:10
    },
    {
      name: "Portugal",
      dialCode: "+351",
      countryCode: "PT",
      maxLength:10
    },
    {
      name: "Puerto Rico",
      dialCode: "+1939",
      countryCode: "PR",
      maxLength:10
    },
    {
      name: "Qatar",
      dialCode: "+974",
      countryCode: "QA",
      maxLength:10
    },
    {
      name: "Romania",
      dialCode: "+40",
      countryCode: "RO",
      maxLength:10
    },
    {
      name: "Russia",
      dialCode: "+7",
      countryCode: "RU",
      maxLength:10
    },
    {
      name: "Rwanda",
      dialCode: "+250",
      countryCode: "RW",
      maxLength:10
    },
    {
      name: "Reunion",
      dialCode: "+262",
      countryCode: "RE",
      maxLength:10
    },
    {
      name: "Saint Barthelemy",
      dialCode: "+590",
      countryCode: "BL",
      maxLength:10
    },
    {
      name: "Saint Helena, Ascension and Tristan Da Cunha",
      dialCode: "+290",
      countryCode: "SH",
      maxLength:10
    },
    {
      name: "Saint Kitts and Nevis",
      dialCode: "+1869",
      countryCode: "KN",
      maxLength:10
    },
    {
      name: "Saint Lucia",
      dialCode: "+1758",
      countryCode: "LC",
      maxLength:10
    },
    {
      name: "Saint Martin",
      dialCode: "+590",
      countryCode: "MF",
      maxLength:10
    },
    {
      name: "Saint Pierre and Miquelon",
      dialCode: "+508",
      countryCode: "PM",
      maxLength:10
    },
    {
      name: "Saint Vincent and the Grenadines",
      dialCode: "+1784",
      countryCode: "VC",
      maxLength:10
    },
    {
      name: "Samoa",
      dialCode: "+685",
      countryCode: "WS",
      maxLength:10
    },
    {
      name: "San Marino",
      dialCode: "+378",
      countryCode: "SM",
      maxLength:10
    },
    {
      name: "Sao Tome and Principe",
      dialCode: "+239",
      countryCode: "ST",
      maxLength:10
    },
    {
      name: "Saudi Arabia",
      dialCode: "+966",
      countryCode: "SA",
      maxLength:10
    },
    {
      name: "Senegal",
      dialCode: "+221",
      countryCode: "SN",
      maxLength:10
    },
    {
      name: "Serbia",
      dialCode: "+381",
      countryCode: "RS",
      maxLength:10
    },
    {
      name: "Seychelles",
      dialCode: "+248",
      countryCode: "SC",
      maxLength:10
    },
    {
      name: "Sierra Leone",
      dialCode: "+232",
      countryCode: "SL",
      maxLength:10
    },
    {
      name: "Singapore",
      dialCode: "+65",
      countryCode: "SG",
      maxLength:10
    },
    {
      name: "Slovakia",
      dialCode: "+421",
      countryCode: "SK",
      maxLength:10
    },
    {
      name: "Slovenia",
      dialCode: "+386",
      countryCode: "SI",
      maxLength:10
    },
    {
      name: "Solomon Islands",
      dialCode: "+677",
      countryCode: "SB",
      maxLength:10
    },
    {
      name: "Somalia",
      dialCode: "+252",
      countryCode: "SO",
      maxLength:10
    },
    {
      name: "South Africa",
      dialCode: "+27",
      countryCode: "ZA",
      maxLength:10
    },
    {
      name: "South Sudan",
      dialCode: "+211",
      countryCode: "SS",
      maxLength:10
    },
    {
      name: "South Georgia and the South Sandwich Islands",
      dialCode: "+500",
      countryCode: "GS",
      maxLength:10
    },
    {
      name: "Spain",
      dialCode: "+34",
      countryCode: "ES",
      maxLength:10
    },
    {
      name: "Sri Lanka",
      dialCode: "+94",
      countryCode: "LK",
      maxLength:10
    },
    {
      name: "Sudan",
      dialCode: "+249",
      countryCode: "SD",
      maxLength:10
    },
    {
      name: "Suriname",
      dialCode: "+597",
      countryCode: "SR",
      maxLength:10
    },
    {
      name: "Svalbard and Jan Mayen",
      dialCode: "+47",
      countryCode: "SJ",
      maxLength:10
    },
    {
      name: "Swaziland",
      dialCode: "+268",
      countryCode: "SZ",
      maxLength:10
    },
    {
      name: "Sweden",
      dialCode: "+46",
      countryCode: "SE",
      maxLength:10
    },
    {
      name: "Switzerland",
      dialCode: "+41",
      countryCode: "CH",
      maxLength:10
    },
    {
      name: "Syrian Arab Republic",
      dialCode: "+963",
      countryCode: "SY",
      maxLength:10
    },
    {
      name: "Taiwan",
      dialCode: "+886",
      countryCode: "TW",
      maxLength:10
    },
    {
      name: "Tajikistan",
      dialCode: "+992",
      countryCode: "TJ",
      maxLength:10
    },
    {
      name: "Tanzania, United Republic of Tanzania",
      dialCode: "+255",
      countryCode: "TZ",
      maxLength:10
    },
    {
      name: "Thailand",
      dialCode: "+66",
      countryCode: "TH",
      maxLength:10
    },
    {
      name: "Timor-Leste",
      dialCode: "+670",
      countryCode: "TL",
      maxLength:10
    },
    {
      name: "Togo",
      dialCode: "+228",
      countryCode: "TG",
      maxLength:10
    },
    {
      name: "Tokelau",
      dialCode: "+690",
      countryCode: "TK",
      maxLength:10
    },
    {
      name: "Tonga",
      dialCode: "+676",
      countryCode: "TO",
      maxLength:10
    },
    {
      name: "Trinidad and Tobago",
      dialCode: "+1868",
      countryCode: "TT",
      maxLength:10
    },
    {
      name: "Tunisia",
      dialCode: "+216",
      countryCode: "TN",
      maxLength:10
    },
    {
      name: "Turkey",
      dialCode: "+90",
      countryCode: "TR",
      maxLength:10
    },
    {
      name: "Turkmenistan",
      dialCode: "+993",
      countryCode: "TM",
      maxLength:10
    },
    {
      name: "Turks and Caicos Islands",
      dialCode: "+1649",
      countryCode: "TC",
      maxLength:10
    },
    {
      name: "Tuvalu",
      dialCode: "+688",
      countryCode: "TV",
      maxLength:10
    },
    {
      name: "Uganda",
      dialCode: "+256",
      countryCode: "UG",
      maxLength:10
    },
    {
      name: "Ukraine",
      dialCode: "+380",
      countryCode: "UA",
      maxLength:10
    },
    {
      name: "United Arab Emirates",
      dialCode: "+971",
      countryCode: "AE",
      maxLength:10
    },
    {
      name: "United Kingdom",
      dialCode: "+44",
      countryCode: "GB",
      maxLength:10
    },
    {
      name: "United States",
      dialCode: "+1",
      countryCode: "US",
      maxLength:10
    },
    {
      name: "Uruguay",
      dialCode: "+598",
      countryCode: "UY",
      maxLength:10
    },
    {
      name: "Uzbekistan",
      dialCode: "+998",
      countryCode: "UZ",
      maxLength:10
    },
    {
      name: "Vanuatu",
      dialCode: "+678",
      countryCode: "VU",
      maxLength:10
    },
    {
      name: "Venezuela, Bolivarian Republic of Venezuela",
      dialCode: "+58",
      countryCode: "VE",
      maxLength:10
    },
    {
      name: "Vietnam",
      dialCode: "+84",
      countryCode: "VN",
      maxLength:10
    },
    {
      name: "Virgin Islands, British",
      dialCode: "+1284",
      countryCode: "VG",
      maxLength:10
    },
    {
      name: "Virgin Islands, U.S.",
      dialCode: "+1340",
      countryCode: "VI",
      maxLength:10
    },
    {
      name: "Wallis and Futuna",
      dialCode: "+681",
      countryCode: "WF",
      maxLength:10
    },
    {
      name: "Yemen",
      dialCode: "+967",
      countryCode: "YE",
      maxLength:10
    },
    {
      name: "Zambia",
      dialCode: "+260",
      countryCode: "ZM",
      maxLength:10
    },
    {
      name: "Zimbabwe",
      dialCode: "+263",
      countryCode: "ZW",
      maxLength:10
    },
  ];
  